import Lookup from 'src/componentes/select2';

const TipoValorMovimentacaoFinanceiraLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/TipoValorMovimentacaoFinanceiraLookup"
    clearable={true}
    {...rest}
  />
);

export default TipoValorMovimentacaoFinanceiraLookup;
